module.exports = __webpack_public_path__ + "img/img_kollus-live.45c76820.png";